import { enhancedApi } from '@store/generated/admin';

export const {
  useGetV2AdminPulseOptionsQuery: usePulseOptionsQuery,
  usePostV2AdminPulseAssignmentsMutation: useAssignPulseMutation,
  useGetV2AdminPulseAssignmentsQuery: usePulseAssignmentsQuery,
} = enhancedApi;

export type {
  PulseAssignmentListResponse,
  PulseAssignmentOptionsResponse,
  PulseAssignmentRequest,
  PulseAssignmentResponse,
} from '@store/generated/admin';
